<template>
  <div style="width: 100%">
    <custom-dragging-table
      :columns="columns"
      :row-key="rowKey"
      :data-list="dataList"
      @draggable="onDraggable"
    >
      <template v-for="(item, i) in customRenders" :slot="item" slot-scope="rowItem">
        <slot :name="item" :text="rowItem.text" :record="rowItem.record" :index="rowItem.index"></slot>
      </template>
    </custom-dragging-table>
    <div class="custom-pagination-box">
      <div style="display: inline-block">
        <slot :name="extraPaginationName" :total="totalCount"/>
      </div>
      <div style="display: inline-block;float: right;" v-if="totalPage>1 && totalCount>currentPageSize">
        <a-pagination
          :total="totalCount"
          :showTotal="total => `总共 ${total} 条`"
          :pageSize="currentPageSize"
          showSizeChanger
          v-model="currentPage"
          @change="onPageChange"
          @showSizeChange="onShowSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomDraggingTable from '@/customComponents/CustomDraggingTable'

export default {
  name: 'CustomPagingDraggingList',
  components: { CustomDraggingTable },
  props: {
    rowKey: {
      type: String,
      default: '',
      require: true
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    requestType: {
      type: String,
      default: 'post'
    },
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    //查询式请求路径
    queryPath: {
      type: String,
      default: ''
    },
    //参数式请求路径
    paramsPath: {
      type: String,
      default: ''
    },
    //请求基础模块
    baseKey: {
      type: String,
      default: ''
    },
    //请求的
    requestPromise: {
      type: Function,
      default: undefined
    },
    loadData: {
      type: Function,
      default: undefined
    },
    //分页附加信息
    extraPaginationName: {
      type: String,
      default: 'extraPaginationName'
    }
  },
  data() {
    return {
      dataList: [],
      customRenders: [],
      currentPage: 1,
      currentPageSize: 10,
      totalCount: 0,
      totalPage: 0
    }
  },
  watch: {
    'columns': function(columnsList) {
      this.customRenders = this.getCustomRendersList(columnsList)
    },
    'pageSize': function(pageSize) {
      this.currentPageSize = pageSize
      setTimeout(() => this.refresh(true), 500)
    }
  },
  mounted() {
    this.currentPage = 1
    this.currentPageSize = this.pageSize
    this.customRenders = this.getCustomRendersList(this.columns)
    this.refresh(true)
  },
  methods: {
    refresh(b = false) {
      if (b) {
        this.currentPage = 1
      }
      this.loadDataRequest({ pageNo: this.currentPage, pageSize: this.currentPageSize })
    },
    loadDataRequest(parameter) {
      return new Promise((resolve, reject) => {
        const result = this.loadData ? this.loadData(parameter) : this.getDefaultDataList(parameter)
        resolve(result)
      }).then(res => {
        this.currentPage = parameter.pageNo
        this.currentPageSize = parameter.pageSize
        this.totalCount = res.totalCount
        this.totalPage = res.totalPage
        this.dataList = res.data
      })
    },

    getCustomRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          // scopedSlots: { customRender: 'state' }
          if (item && item.scopedSlots && item.scopedSlots.customRender) {
            customList.push(item.scopedSlots.customRender)
          }
        })
      }
      return customList
    },
    //加载接口默认实现
    getDefaultDataList(parameter) {
      let requestPromise
      if ((this.queryPath || this.paramsPath) && this.requestType && this.baseKey) {//传统的老项目请求方式
        let path
        if (this.paramsPath) {
          path = this.paramsPath + '/' + parameter.pageNo + '/' + parameter.pageSize
        } else {
          path = this.queryPath + '?pageNum=' + parameter.pageNo + '&pageSize=' + parameter.pageSize
        }
        const baseService = this.getHttpServices().getCommonService(this.baseKey)
        requestPromise = this.requestType === 'post' ? baseService.post(path, this.queryParams) : baseService.get(path, this.queryParams)
      } else {
        let requestParams
        if (this.requestType === 'post') {
          requestParams = {
            ...this.queryParams,
            limitDto: {
              pageNum: parameter.pageNo,
              pageSize: parameter.pageSize
            }
          }
        } else {
          requestParams = {
            pageSize: parameter.pageSize,
            pageNum: parameter.pageNo,
            ...this.queryParams
          }
        }
        this.getLogUtils().logWithTag('requestParams', requestParams)
        requestPromise = this.requestPromise(requestParams)
      }

      return requestPromise.then(res => {
        if (!this.rowKey && res.data && res.data.length > 0) {
          //没有传key，则自动构建一个唯一的可以
          for (let i = 0, len = res.data.length; i < len; i++) {
            this.autoRowNum = this.autoRowNum + i
            res.data[i][this.autoRowKey] = this.autoRowKey + this.autoRowNum
          }
        }
        return {
          pageSize: parameter.pageSize,
          pageNo: parameter.pageNo,
          totalCount: res.totalCount,
          totalPage: res.pageCount,
          data: res.data
        }
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        return {
          pageSize: parameter.pageSize,
          pageNo: parameter.pageNo,
          totalCount: 0,
          totalPage: 0,
          data: []
        }
      })
    },
    getWidth(width) {
      if (width.endsWith('%') || width.endsWith('px')) {
        return width
      } else {
        return width + 'px'
      }
    },
    onDraggable(dataList) {
      this.dataList = dataList
      let params = {
        pageNo: this.currentPage,
        pageSize: this.currentPageSize,
        dataList: this.dataList
      }
      this.$emit('draggable', params)
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.currentPageSize = pageSize
      setTimeout(() => this.refresh(true), 500)
    },
    onPageChange(page, pageSize) {
      this.currentPage = page
      this.currentPageSize = pageSize
      setTimeout(() => this.refresh(false), 500)
    }
  }

}
</script>
<style scoped>
.table-header {
  width: 100%;
  height: 80px;
}

.table-default-item {
  height: 100%;
  flex: 1;
  display: inline-block;
}

.item-box {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E9E9E9;
}
</style>